// @ts-nocheck

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { notification } from "antd";
import { http } from "../../../engine/api/http";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import routes from "../../../engine/routes";
import { useNavigate, useParams } from "react-router-dom";
import { onlyRoleMapping } from "../../../engine/AuthRoute";
import { roles } from "../../../utils/constants";

const initialState = {
  users: [],
  institution: {
    _id: undefined,
    defaultAddress: null,
    name: "",
    secondName: "",
    interventionLocation: "",
    type: "",
    mainType: "",
    archived: false,
    groupedBilling: false,
    tags: [],
    billings: [],
  },
  loading: false,
};

export const getInstitution = createAsyncThunk(
  "institution/getInstitution",
  async (institutionId, thunkAPI) => {
    const res = await http.get("/institutions/" + institutionId);
    return res.data;
  },
);

export const deleteInstitution = createAsyncThunk(
  "institution/deleteInstitution",
  async (institutionId, thunkAPI) => {
    const res = await http.delete("/institutions/" + institutionId);
    return res.data;
  },
);

export const getInstitutionUsers = createAsyncThunk(
  "institution/getInstitutionUsers",
  async (institutionId, thunkAPI) => {
    const res = await http.get("/institutions/" + institutionId + "/users");
    return res.data.sort((a, b) =>
      a.info.lastname.localeCompare(b.info.lastname),
    );
  },
);

export const updateInstitution = createAsyncThunk(
  "institution/update",
  async (payload, thunkAPI, state) => {
    const institution = thunkAPI.getState().institution.institution;


    if (institution._id !== undefined) {
      const res = await http.patch(
        "/institutions/" + institution._id,
        institution,
      );
      notification.success({
        message: `Modifica Cliente`,
      });
      return res.data;
    } else {
      const res = await http.post("/institutions/new", institution);
      // thunkAPI.dispatch(updateInstitutionOnList(res.data));
      notification.success({
        message: `Cliente creata`,
      });
      return res.data;
    }
  },
);

const institutionSlice = createSlice({
  name: "institution",
  initialState,
  reducers: {
    clearInstitution: state => {
      return initialState;
    },
    setPropertiesInstitution: (state, action) => {
      state.institution = { ...state.institution, ...action.payload };
    },
  },
  extraReducers: {
    [getInstitution.pending]: (state, { payload }) => {
      state.loading = true;
    },
    [getInstitution.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.institution = payload;
    },
    [deleteInstitution.pending]: (state, { payload }) => {
      state.loading = true;
    },
    [deleteInstitution.fulfilled]: (state, { payload }) => {
      return initialState;
    },
    [updateInstitution.pending]: (state, { payload }) => {},
    [updateInstitution.fulfilled]: (state, { payload }) => {
      state.institution = payload;
    },
    [getInstitution.rejected]: state => {
      state.loading = false;
    },
    [getInstitutionUsers.pending]: state => {
      state.loading = true;
    },
    [getInstitutionUsers.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.users = payload;
    },
  },
});

export const initInstitutionSlice = ({}) => {
  const dispatch = useDispatch();

  const { id } = useParams();

  const { institution, loading } = useSelector(state => state.institution);
  const navigate = useNavigate();

  const init = async () => {
    if (institution._id !== id && id !== "new" && loading === false) {
      await dispatch(getInstitution(id));
      await dispatch(getInstitutionUsers(id));
    }
  };

  const clear = async () => {
    await dispatch(clearInstitution());
  };

  useEffect(() => {
    if (
      institution._id !== undefined &&
      id === "new" &&
      institution._id !== id
    ) {
      navigate(routes.institutions(institution._id).detail.path, {
        replace: true,
      });
    }
  }, [institution]);

  useEffect(() => {
    const allAwait = async () => {
      await init();


      if (id === "new" && onlyRoleMapping([roles.admin, roles.permanance])) {
        await clear();
        navigate(routes.root().path, {
          replace: true,
        });
      }

      if (
        id === "new" &&
        institution._id !== undefined &&
        institution._id !== id
      ) {
        // Reset when go to a new one
        await clear();
        navigate(routes.institutions().new.path, {
          replace: true,
        });
      }
    };


    allAwait();

    return () => {
      // clear();
    };
  }, []);

  return { init, clear };
};

export const {
  clearInstitution,
  setPropertiesInstitution,
} = institutionSlice.actions;

export const institutionReducer = institutionSlice.reducer;
